<template>
    <div class="counter-container">
        <div v-for="(item,index) in numArr" :key="index" class="num-item">
            <span class="pointer" v-if="item ==','||item =='.'" >{{item}}</span>
            <span :id="`hostItem${id}${index}`" v-else class="num">{{flipNum}}</span>
        </div>
    </div>
</template>
<script>
import { ref,watch,onMounted,nextTick } from "vue";
export default {
    props:{
        num:{
            type:Number,
            default:0
        },
        duration:{
            type:Number,
            default:1,
        },
        id:{
            type:String,
            default:'',
        },
    },
    setup(props) {
        let numArr = ref(['0', '0', '0', '0', '0', '0', '0', '0', '0', '0'])
        const flipNum = '0123456789'
        function numToArr(){
            // const str = props.num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,",");
            const str = props.num.toString();
            let string = str.split("")
            if (string.length < 9) {
                let count = 9 - string.length
                for (let i = 0; i < count; i++) {
                    string.unshift({ num: '0', show: true })
                };
            }
            numArr.value = string
        }
        function rollNum(){
            numArr.value.forEach((item,index)=>{
                const num = parseInt(item);
                const numItem = document.getElementById('hostItem'+props.id+[index]);
                if(numItem){
                    numItem.style.transform = `translate(-50%, -${num * 10}%)`;
                }
            })
        }
        const initNumber = ()=>{
            numToArr();
            nextTick(()=>{
                setTimeout(()=>{
                    rollNum()
                },1000)
            })
        }
        onMounted(()=>{
            initNumber()
        })
        return{
            numArr,
            flipNum,
            numToArr,
            rollNum,
            initNumber,
        }
    }
}
</script>
<style lang="less" scoped>
.counter-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    // padding-bottom: 4vh;
    .num-item{
        position: relative;
        box-sizing: border-box;
        width: 1.25vw;
        height: 3.889vh;
        margin-left: 0.6vw;
        overflow: hidden;
        font-size: 1.4vw;
        font-weight: bold;
        color: #fff;
        text-align: center;
        background: linear-gradient(
            to bottom, #006a82 0%, #006a82 50%, #1c93ad 50%,#1c93ad 100%
        );
    }
    .num{
        font-family: MyBinBold;
        position: absolute;
        top: calc(50% - 0.9vw);
        left: 50%;
        letter-spacing: 3.889vh;
        writing-mode: vertical-lr;
        transition: all 1s ease-in-out;
        transform: translate(-50%,0);
        text-orientation: upright;
    }
}

</style>